__webpack_require__.p = "/projects/politics/new-york-bill-tracker/";